import React, { useState } from 'react'
import plusSvg from '../images/accordion-plus.svg'
import minusSvg from '../images/accordion-minus.svg'

interface Props {
  titles: string[]
  descriptions: string[]
}

const AccordionItem: React.FC<{
  title: string
  content: string
}> = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => {
    setIsExpanded((prevIsExpanded) => !prevIsExpanded)
  }

  return (
    <div className="accordion-item pt-1">
      <div
        className={`accordion-header ${isExpanded ? 'active' : ''}`}
        onClick={handleToggle}
        aria-expanded={isExpanded}
      >
        <div className="accordion-title font-bold">{title}</div>
        <div className="accordion-icon">
          <img
            src={isExpanded ? minusSvg : plusSvg}
            alt={isExpanded ? 'collapse' : 'expand'}
            style={{
              width: '16px',
              height: '16px',
            }}
          />
        </div>
      </div>
      {isExpanded && (
        <div className="accordion-body">
          <p>{content}</p>
        </div>
      )}
    </div>
  )
}

const Accordion: React.FC<Props> = ({ titles, descriptions }) => {
  return (
    <div className="accordion-container">
      {titles.map((title, index) => {
        return (
          <AccordionItem
            title={titles[index]}
            content={descriptions[index]}
            key={`acc-${index}`}
          />
        )
      })}
    </div>
  )
}

export default Accordion
